import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PanelGroup from './PanelGroup';

var Accordion = function Accordion(_ref) {
  var unhandledProps = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(PanelGroup, _extends({}, unhandledProps, {
    accordion: true
  }));
};

Accordion.displayName = 'Accordion';
export default Accordion;